import { FIND_BOOKING_COOKIE_NAME_KEY } from '@whitbread-eos/api';
import { deleteCookie, getCookie } from '../helpers/cookies';
import { isStringValid } from '../validators';
export var getFindBookingToken = () => {
  if (typeof window !== 'undefined') {
    var _window$localStorage$;
    var cookieName = (_window$localStorage$ = window.localStorage.getItem(FIND_BOOKING_COOKIE_NAME_KEY)) !== null && _window$localStorage$ !== void 0 ? _window$localStorage$ : '';
    if (isStringValid(cookieName)) {
      var cookieTokenValue = getCookie(cookieName);
      if (cookieTokenValue) {
        try {
          var cookieValue = JSON.parse(window.atob(cookieTokenValue));
          return {
            token: cookieValue.token,
            basketReference: cookieValue.basketReference,
            bookingReference: cookieValue.bookingReference,
            operaConfNumber: cookieValue.operaConfNumber
          };
        } catch (e) {
          return {};
        }
      }
    }
  }
  return {};
};
export var cleanupFindBookingToken = () => {
  if (typeof window !== 'undefined') {
    var _window$localStorage$2;
    var cookieName = (_window$localStorage$2 = window.localStorage.getItem(FIND_BOOKING_COOKIE_NAME_KEY)) !== null && _window$localStorage$2 !== void 0 ? _window$localStorage$2 : '';
    deleteCookie(cookieName);
    window.localStorage.removeItem(FIND_BOOKING_COOKIE_NAME_KEY);
  }
};